'use client';

import { resolveNumber, resolveText } from '@macaron-a2ui/core/v0_8';
import { MACARON } from './tokens';
import type { MacaronRenderContext, RecordAny } from '@macaron-a2ui/core/v0_8';

function starFillFraction(rating: number, starIndex: number): number {
  return Math.max(0, Math.min(1, rating - starIndex));
}

export function MacaronRating({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const rating = Math.max(0, Math.min(5, resolveNumber(config.rating, ctx.data)));
  const label = config.text ? resolveText(config.text, ctx.data) : '';

  return (
    <div className="flex min-w-0 items-center gap-2">
      <div className="flex items-center gap-0.5">
        {[0, 1, 2, 3, 4].map((i) => {
          const frac = starFillFraction(rating, i);
          return (
            <div key={i} className="relative h-3 w-[13px] overflow-hidden">
              <span className="absolute inset-0 text-[12px] leading-[12px]" style={{ color: MACARON.ratingStarUnselected }}>
                ★
              </span>
              {frac > 0 ? (
                <span className="absolute inset-0 overflow-hidden text-[12px] leading-[12px]" style={{ color: MACARON.ratingStarSelected, width: `${frac * 100}%` }}>
                  ★
                </span>
              ) : null}
            </div>
          );
        })}
      </div>
      {label ? (
        <span className="font-sans text-[12px] font-normal leading-[1.5]" style={{ color: MACARON.ratingText }}>
          {label}
        </span>
      ) : null}
    </div>
  );
}
